import { render, staticRenderFns } from "./privacyMerchant.vue?vue&type=template&id=533ad90c&scoped=true"
import script from "./privacyMerchant.vue?vue&type=script&lang=js"
export * from "./privacyMerchant.vue?vue&type=script&lang=js"
import style0 from "./privacyMerchant.vue?vue&type=style&index=0&id=533ad90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ad90c",
  null
  
)

export default component.exports